import axios from 'axios';
import { MDBBtn, MDBContainer, MDBDatatable, MDBIcon } from 'mdb-react-ui-kit';
import React, {useEffect, useState } from 'react';
export default function ContactsView() {
  const [contacts, setContacts] = useState([]);
  const baseUrl = process.env.REACT_APP_INVENTORY_URL;

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await axios.get(`${baseUrl}/contacts`);
        if (response.status === 200) {
          setContacts(response.data.map((contact) => {
            return {
              firstName: contact.firstName,
              lastName: contact.lastName,
              phone: contact.phone,
              email: contact.email,
              subject: contact.subject,
              message: contact.message,
              date: new Date(contact.date.modifiedDate).toLocaleDateString(undefined, {
                weekday: 'long',
                day: '2-digit',
                month: 'long',
                year: 'numeric',
              }),
              contact: (
                <>
                  <MDBBtn outline size='sm' floating className='call-btn' onClick={() => console.log(`call ${contact.phone}`)}>
                    <MDBIcon icon='phone' />
                  </MDBBtn>
                  <MDBBtn
                    size='sm'
                    floating
                    className='message-btn ms-2'
                    onClick={() => console.log(`send a message to ${contact.email}`)}
                  >
                    <MDBIcon icon='envelope' />
                  </MDBBtn>
                </>
              ),
            };
          }));
        }
      } catch (error) {
        // Handle error
        console.error('An error occurred while fetching data: ', error);
      }
    };
  
    fetchContacts();
  }, [baseUrl]);
  

  const actionData = {
    columns: [
      { label: 'First Name', field: 'firstName' },
      { label: 'Last Name', field: 'lastName' },
      { label: 'Phone', field: 'phone' },
      { label: 'Email', field: 'email' },
      { label: 'Subject', field: 'subject' },
      { label: 'Message', field: 'message' },
      { label: 'Date', field: 'date' },
      { label: 'Contact', field: 'contact', sort: false },
    ],
    rows: contacts,
  };

  return (
    <MDBContainer>
    <MDBDatatable className="mb-2 mt-4 rounded position-relative grainy-gradient-intro" hover data={actionData} />
    </MDBContainer>
  );
}
